<ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="desktopTemplate">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #nohomefilter>
    <ng-container [ngSwitch]="desktopTemplate">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="nohomefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #homemodeMobile>
    <div class="tmp-extra-wrapper-mobile">
        <div class="tmp-section-wrapper-mobile">
            <clever-selectionbtn [title]="'Beliebte Filter'" [isMultiselect]="true" [isCheckBox]="false"
                [list]="ferienFiltersService.beliebteFilter" (sendRes)="beliebteFilterCahnge($event)">
            </clever-selectionbtn>
        </div>
    </div>
    <div class="tmp-footer-mobile">
        <button class="mb1" (click)="resetAllExtra()" matRipple>
            <span>Alle Filter löschen</span>
        </button>
        <span></span>
    </div>
</ng-template>

<ng-template #homefilterdesk>
    <div class="tmp-extra-wrapper">
        <clever-selectionbtn [title]="'Beliebte Filter'" [isMultiselect]="true" [isCheckBox]="false"
            [list]="ferienFiltersService.beliebteFilter" (sendRes)="beliebteFilterCahnge($event)">
        </clever-selectionbtn>
    </div>
    <div class="tmp-footer">
        <span></span>
        <div class="tmp-flexy">
            <button class="tmp-reset-btn" (click)="resetAll()" matRipple>
                <span>Alle Filter löschen</span>
            </button>
            <button class="tmp-close-btn" (click)="closeextras()" matRipple>
                <span>Schließen</span>
                <mat-icon>arrow_drop_up</mat-icon>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #nohomefilterdesk>
    <div class="nohome-wrapper-desk">
        <ng-container *ngTemplateOutlet="myfilters"></ng-container>
    </div>
</ng-template>

<ng-template #nohomemodeMobile>
    <div class="nohome-wrapper">
        <ng-container *ngTemplateOutlet="myfilters"></ng-container>
    </div>
</ng-template>

<ng-template #myfilters>
    @if(!hidenmapfilter) {
        <ng-container *ngTemplateOutlet="mapbutton"></ng-container>
    }
    <clever-selectionbtn [title]="'Beliebte Filter'" [isMultiselect]="true" [isCheckBox]="true"
        [list]="ferienFiltersService.beliebteFilter" (sendRes)="beliebteFilterCahnge($event)">
    </clever-selectionbtn>
    <clever-selectionbtn [title]="'Art der Unterkunft'" [isMultiselect]="true" [isCheckBox]="true"
        [list]="ferienFiltersService.types" (sendRes)="typesCahnge($event)">
    </clever-selectionbtn>
    <clever-selectionbtn [title]="'Ausstattung'" [isMultiselect]="true" [isCheckBox]="true"
        [list]="ferienFiltersService.amenities" (sendRes)="amenitiesCahnge($event)">
    </clever-selectionbtn>
    <div class="tmp-section-item-wrapper">
        <span class="tmp-section-title">Preis pro Nacht</span>
        <div class="tmp-section-body">
            <div class="range-slider">
                <input type="range" [max]="990" [min]="9" (touchend)="dblpricechange()" (mouseup)="dblpricechange()"
                    [(ngModel)]="ferienFiltersService.minPrice" />
                <input type="range" [max]="1001" [min]="9" (touchend)="dblpricechange()" (mouseup)="dblpricechange()"
                    [(ngModel)]="ferienFiltersService.maxPrice" />
            </div>
            <div class="dbllabel">
                <span>{{ferienFiltersService.minPrice}} €</span>
                <span>{{ferienFiltersService.maxPrice < 1000 ? (ferienFiltersService.maxPrice + '€' ) : 'beliebig'
                        }}</span>
            </div>
        </div>
    </div>
    <div class="tmp-section-item-wrapper">
        <span class="tmp-section-title">Zimmer</span>
        <div class="cc3">
            <span>Schlafzimmer</span>
            <div class="cc4">
                <button matRipple class="cc5" (click)="removeBedrooms()"><mat-icon>remove</mat-icon></button>
                <div class="cc6">{{ferienFiltersService.bedrooms}}</div>
                <button matRipple class="cc5" (click)="addBedrooms()"><mat-icon>add</mat-icon></button>
            </div>
        </div>
    </div>
    <div class="tmp-section-item-wrapper">
        <span class="tmp-section-title mtr1">Entfernung zum Stadtzentrum</span>
        <button class="tour-item-wrapper" (click)="selectToZenter(1000)" matRipple>
            <mat-icon class="tour-item-icon ">{{ferienFiltersService.toCenter === 1000 ? 'radio_button_checked' :
                'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">Weniger als 1km</span>
        </button>
        <button class="tour-item-wrapper" (click)="selectToZenter(3000)" matRipple>
            <mat-icon class="tour-item-icon ">{{ferienFiltersService.toCenter === 3000 ? 'radio_button_checked' :
                'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">Weniger als 3km</span>
        </button>
        <button class="tour-item-wrapper" (click)="selectToZenter(10000)" matRipple>
            <mat-icon class="tour-item-icon ">{{ferienFiltersService.toCenter === 10000 ? 'radio_button_checked' :
                'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">Weniger als 10km</span>
        </button>
        <button class="tour-item-wrapper" (click)="selectToZenter(null)" matRipple>
            <mat-icon class="tour-item-icon ">{{(ferienFiltersService.toCenter === null || ferienFiltersService.toCenter
                === undefined) ? 'radio_button_checked' : 'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">Beliebig</span>
        </button>
    </div>
    <div class="tmp-section-item-wrapper">
        <span class="tmp-section-title mtr1">Entfernung vom Wasser</span>
        <button class="tour-item-wrapper" (click)="selectToWater(1000)" matRipple>
            <mat-icon class="tour-item-icon ">{{ferienFiltersService.toWater === 1000 ? 'radio_button_checked' :
                'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">Weniger als 1km</span>
        </button>
        <button class="tour-item-wrapper" (click)="selectToWater(3000)" matRipple>
            <mat-icon class="tour-item-icon ">{{ferienFiltersService.toWater === 3000 ? 'radio_button_checked' :
                'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">Weniger als 3km</span>
        </button>
        <button class="tour-item-wrapper" (click)="selectToWater(10000)" matRipple>
            <mat-icon class="tour-item-icon ">{{ferienFiltersService.toWater === 10000 ? 'radio_button_checked' :
                'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">Weniger als 10km</span>
        </button>
        <button class="tour-item-wrapper" (click)="selectToWater(null)" matRipple>
            <mat-icon class="tour-item-icon ">{{(ferienFiltersService.toWater === null || ferienFiltersService.toWater
                === undefined) ? 'radio_button_checked' : 'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">Beliebig</span>
        </button>
    </div>
    <div class="tmp-section-item-wrapper">
        <span class="tmp-section-title mtr1">Entfernung Skigebiet oder Skipiste</span>
        <button class="tour-item-wrapper" (click)="selectToSki(1000)" matRipple>
            <mat-icon class="tour-item-icon ">{{ferienFiltersService.toSki === 1000 ? 'radio_button_checked' :
                'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">Weniger als 1km</span>
        </button>
        <button class="tour-item-wrapper" (click)="selectToSki(3000)" matRipple>
            <mat-icon class="tour-item-icon ">{{ferienFiltersService.toSki === 3000 ? 'radio_button_checked' :
                'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">Weniger als 3km</span>
        </button>
        <button class="tour-item-wrapper" (click)="selectToSki(10000)" matRipple>
            <mat-icon class="tour-item-icon ">{{ferienFiltersService.toSki === 10000 ? 'radio_button_checked' :
                'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">Weniger als 10km</span>
        </button>
        <button class="tour-item-wrapper" (click)="selectToSki(null)" matRipple>
            <mat-icon class="tour-item-icon ">{{(ferienFiltersService.toSki === null || ferienFiltersService.toSki ===
                undefined) ? 'radio_button_checked' : 'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">Beliebig</span>
        </button>
    </div>
    <div class="tmp-section-item-wrapper">
        <span class="tmp-section-title mtr1">Bewertung</span>
        <button class="tour-item-wrapper" (click)="selectRating('outstanding')" matRipple>
            <mat-icon class="tour-item-icon ">{{ferienFiltersService.rating === 'outstanding' ? 'radio_button_checked' :
                'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">4,5+</span>
        </button>
        <button class="tour-item-wrapper" (click)="selectRating('very_good')" matRipple>
            <mat-icon class="tour-item-icon ">{{ferienFiltersService.rating === 'very_good' ? 'radio_button_checked' :
                'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">4+</span>
        </button>
        <button class="tour-item-wrapper" (click)="selectRating(null)" matRipple>
            <mat-icon class="tour-item-icon ">{{(ferienFiltersService.rating === null || ferienFiltersService.rating ===
                undefined) ? 'radio_button_checked' : 'radio_button_unchecked'}}</mat-icon>
            <span class="tour-item-name">Beliebig</span>
        </button>
    </div>
</ng-template>

<ng-template #skloading>
    <div style="width: 100%;display: flex;flex-direction: column;margin-bottom: 1rem;">
        <div class="skeleton" style="height: 20px;width: 200px;margin-top: .5rem;"></div>
        <div class="skeleton" style="height: 20px;width: 150px;margin-top: .5rem;"></div>
        <div class="skeleton" style="height: 20px;width: 100px;margin-top: .5rem;"></div>
    </div>
</ng-template>


<ng-template #mapbutton>
    <button class="mapwrapper noselect" (click)="openMapModal()">
        <img class="lazyload mapimg" data-src="../../../assets/img/mapimg.png">
        <div class="mapbtnwrapper">
            <div class="mapbtn">
                <mat-icon class="mapbtnicon">place</mat-icon>
                <span class="mapbtntext">Karte ansehen</span>
            </div>
        </div>
    </button>
</ng-template>